import React, { useState, useEffect } from "react"; 
import { Link } from "react-router-dom"; 
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { User, List } from "react-feather"; 
import { baseurl } from "../../Baseurl";

const SellerDashboard = () => {
  const seller_id = localStorage.getItem("seller_id");
  const [dashboardData, setDashboardData] = useState({
    listing_count: 0,
    enquiry_count: 0,
    quote_request_count: 0,
  });

  useEffect(() => {
    const fetchListingCount = async () => {
      try {
        const response = await axios.get(`${baseurl}getSellerDashboardCount/${seller_id}`);
        if (response.data && response.data.data) {
          setDashboardData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    if (seller_id) {
      fetchListingCount();
    }
  }, [seller_id]);

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">Seller Dashboard</h4>
                  <hr />

                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-3">
                      <Link to="/seller/all-listing" style={{ textDecoration: 'none' }}>
                      <div className="ag1 bgg2 p-2 text-start">
                        <div className="ag4 mb-3">
                          <span className="agsvg1 bbg2 p-2">
                            <List />
                          </span>
                        </div>
                        <div className="ag2 font4">
                          {Number(dashboardData.listing_count || 0).toLocaleString('en-IN')}
                          </div>
                        <div className="ag3 font4">Total Listings</div>
                      </div>
                      </Link>
                    </div> 

                    <div className="col-md-3">
                      
                      <div className="ag1 bgg2 p-2 text-start">
                        <div className="ag4 mb-3">
                          <span className="agsvg1 bbg2 p-2">
                            <List />
                          </span>
                        </div>
                        <div className="ag2 font4">{Number(dashboardData.enquiry_count || 0).toLocaleString('en-IN')}</div>
                        <div className="ag3 font4">Total Inquiries</div>
                      </div>
                    </div> 

                    <div className="col-md-3">
                      <div className="ag1 bgg2 p-2 text-start">
                        <div className="ag4 mb-3">
                          <span className="agsvg1 bbg2 p-2">
                            <List />
                          </span>
                        </div>
                        <div className="ag2 font4">{Number(dashboardData.quote_request_count || 0).toLocaleString('en-IN')}</div>
                        <div className="ag3 font4">Quote Requests</div>
                      </div>
                    </div> 


                    <div className="col-md-3">
                      <Link to="/seller/service-request" style={{ textDecoration: 'none' }}>
                      <div className="ag1 bgg2 p-2 text-start">
                        <div className="ag4 mb-3">
                          <span className="agsvg1 bbg2 p-2">
                            <List />
                          </span>
                        </div>
                        <div className="ag2 font4">{Number(dashboardData.service_request_count || 0).toLocaleString('en-IN')}</div>
                        <div className="ag3 font4">Service Requests</div>
                      </div>
                      </Link>
                    </div> 



                    <div className="col-md-3">
                      <div className="ag1 bgg2 p-2 text-start">
                        <div className="ag4 mb-3">
                          <span className="agsvg1 bbg2 p-2">
                            <List />
                          </span>
                        </div>
                        <div className="ag2 font4">
                      {Number(dashboardData.total_stock_value || 0).toLocaleString('en-IN')}
</div>
                        <div className="ag3 font4">Total Stock Value</div>
                      </div>
                    </div> 

                    {/* You can add more cards below if needed */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SellerDashboard;
